// SessionGuard.tsx
import React, { useEffect, useState } from 'react';
import { isSessionExpired, clearLoginCookies, getRemainingSeconds } from '@/lib/sessionCookie';
import { useNavigate } from 'react-router-dom';

type Props = { children: React.ReactNode; redirectTo?: string };

export default function SessionGuard({ children, redirectTo = '/login' }: Props) {
  const [expired, setExpired] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // ページ入場時に判定
    if (isSessionExpired()) {
      setExpired(true);
      clearLoginCookies();
      return;
    }

    // 残り秒数で自動失効（ページを開いたままでも切れる）
    const remain = getRemainingSeconds();
    const timer = window.setTimeout(() => {
      setExpired(true);
      clearLoginCookies();
    }, remain * 1000);

    return () => window.clearTimeout(timer);
  }, []);

  if (expired) {
    return (
      <div className="mx-auto my-12 max-w-xl rounded-lg border border-amber-300 bg-amber-50 p-6 text-amber-900">
        <h2 className="mb-2 text-lg font-semibold">セッションが切れました</h2>
        <p className="mb-4 text-sm">
          セキュリティ保護のため一定時間操作がない場合は自動的にログアウトされます。お手数ですが、再度ログインしてください。
        </p>
        <button
          className="rounded-md border px-4 py-2"
          onClick={() => navigate(redirectTo, { replace: true })}
        >
          ログインへ
        </button>
      </div>
    );
  }

  return <>{children}</>;
}
